import React from "react";
import "./CTProductPreviewCard.scss";
import {
  MotifButton,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifTheme,
  MotifTruncate,
} from "@ey-xd/motif-react";
interface CTProductCardProps {
  ProductId: string;
  Name: string;
  Description: string;
  rejectedMessage?: string;
  statusCd: string;
  statusName: string;
  setShowUpdateSkus: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedSku: React.Dispatch<React.SetStateAction<string>>;
  selectedSku: string;
  disabled: boolean;
}

const CTProductPreviewCard: React.FC<CTProductCardProps> = ({
  ProductId,
  Name,
  Description,
  rejectedMessage = "",
  statusCd = "active-billed", // remove default value if not needed
  statusName,
  setSelectedSku,
  setShowUpdateSkus,
  selectedSku,
  disabled = false,
}) => {
  const handleCardClick = () => {
    console.log(`Product ID: ${ProductId}`);
    console.log(setSelectedSku, setShowUpdateSkus, selectedSku);
  };
  //const isHavingActiveStatus = statusCd.toLowerCase().includes("active");
  const [isStatusClicked, setIsStatusClicked] = React.useState(false);

  const handleStatusClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsStatusClicked(true);
  };

  const handleCancelClick = () => {
    setIsStatusClicked(false);
    document.body.style.overflow = "";
  };

  const rejectedreasonModal = () => {
    return (
      <>
        <MotifTheme variant={"dark"}></MotifTheme>
        <MotifModal
          show={isStatusClicked}
          onClose={handleCancelClick}
          className="rejected-reason-modal"
          size="sm"
        >
          <MotifModalHeader>BMO rejected reason</MotifModalHeader>
          <MotifModalBody>
            <p className="assign-proxy-txt">
              {statusCd === "sku_rejected" && rejectedMessage}
            </p>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              onClick={handleCancelClick}
              className="ct-assign-product-cancel"
              type="button"
            >
              Close
            </MotifButton>
          </MotifModalFooter>
        </MotifModal>
      </>
    );
  };
  const editButtonDisabled =
    statusCd.toLowerCase() === "sku_retired" || disabled;
  return (
    <div
      className={`ct-productPreview-card ${statusCd}`}
      onClick={handleCardClick}
    >
      <MotifTruncate
        maxLines={1}
        maxWidth={330}
        className="ct-productPreview-card-title"
        tooltipProps={{ placement: "top" }}
      >
        {Name}
      </MotifTruncate>
      <div className="ct-productPreview-card-body">
        <div
          onClick={statusCd === "sku_rejected" ? handleStatusClick : undefined}
          className={`ct-productPreview-card-status-grid ${statusCd}`}
        >
          <span className={`circle ${statusCd}`}></span>
          <span className={`ct-productPreview-card-status ${statusCd}`}>
            {statusName}{" "}
          </span>
        </div>
        <div className="ct-productPreview-card-description">
          <div
            dangerouslySetInnerHTML={
              Description
                ? { __html: Description.replace(/&nbsp;/g, " ") }
                : undefined
            }
          ></div>
        </div>
      </div>
      <div className="ct-productPreview-card-footer">
        <MotifButton
          size="medium"
          type="submit"
          variant="secondary"
          className={`ct-productPreview-card-btn-preview ${statusCd}`}
          disabled={editButtonDisabled}
          onClick={() => {
            setShowUpdateSkus(true);
            setSelectedSku(selectedSku);
          }}
        >
          {"Edit"} &gt;
        </MotifButton>
        {isStatusClicked && rejectedreasonModal()}
      </div>
    </div>
  );
};

export default CTProductPreviewCard;
